const PlaceHolder = {
  // 공통
  USER_NAME: '회원 이름',
  USER_ACCOUNT: '회원 아이디',
  USER_EMAIL: '회원 이메일',
  REJECT_TEL: '수신 거부 전화번호',

  // 쇼핑몰 정보
  MALL_NAME: '쇼핑몰/매장 이름',
  MALL_URL: '매장/쇼핑몰 대표 도메인',
  BIZ_TEL: '대표 전화번호',
  MALL_TEL: '상담/주문 전화번호',
  MALL_EMAIL: '상담/주문 이메일',

  // 문의 관련
  BOARD_NAME: '게시판 이름',
  SUBJECT: '글 제목',

  // 날짜
  DATE: '날짜',

  // 주문 관련
  PRODUCT: '상품명',
  PRODUCT_COUNT: '상품 수량',
  READY_COUNT: '조리 준비 대기 수량',
  SERIAL_NUMBER: '주문 번호',
  PRICE: '주문 금액',
  ORDER_URL: '비회원 주문 조회 페이지',
  INVOICE_NUMBER: '운송장번호',
  DELIVERY_COMPANY: '택배사',

  // 환불 관련
  REFUND_PRICE: '환불 금액',
  REFUND_REASON: '환불 사유',
  REFUND_TABLE: '환불 내역',

  // 무통장 입금 관련
  BANK: '입금 은행',
  ACCOUNT: '입금 계좌번호',
  DEPOSITOR: '예금주',
  AUTOCANCELDATE: '입금 만료일',
  ACCOUNT_HOLDER: '입금자명',

  // 택배 관련
  DELICOM: '택배사 이름',
  DELINUM: '송장 번호',

  // 회원 등급 관련
  OLD_GRADE: '변경 전 회원 등급',
  CURRENT_GRADE: '변경 후 회원 등급',
  GRADE_CHANGE: '회원 등급 변경일자',

  // 정기배송 관련
  FAILMSG: '실패 사유 안내문구',
  GUIDMSG: '실패 가이드 문구',
  RDORDERID: '정기배송 신청 번호',

  // 쿠폰명
  COUPON_NAME: '쿠폰명',

  // 이메일 문자
  AUTH_CODE: '이메일/문자 인증 코드',

  // 이메일 전용 - 쇼핑몰
  MALL_BUSINESS_NAME: '상호명',
  MALL_ADDRESS: '사업장 주소',
  MALL_CEO: '대표자',
  MALL_CPO: '개인정보 책임자',
  MALL_BUSINESS_NUM: '사업자등록번호',
  MALL_NETWORK_NO: '통신판매업 신고번호',
  MALL_BRAND_NAME: '푸터 하단 브랜드 명',

  // 이메일 전용 - 회원
  USER_SIGNUP_ROUTE: '가입경로',

  // 이메일 전용 - 주문
  PRODUCT_TABLE: '상품목록 테이블',
  PAYMENT_TABLE: '결제정보 테이블',
  DELIVERY_ADDRESS_TABLE: '배송지 테이블',
};

export default PlaceHolder;
